import { useLocation } from 'react-router-dom';
import { useChildNav } from './useChildNav';

// Screens that get their own URL under a hub's sub-tab, e.g. /herd/animals/add.
// Dashboard.js registers an exact route for each, so they take priority over
// detail routes like /herd/lots/:lotId.
export const FORM_SCREENS = ['add', 'upload'];

// useHubScreen gives a hub its sub-tab, in-tab screen and record id from the URL:
//   /herd/animals                   { subTab: 'animals', screen: 'list' }
//   /herd/animals/add               { subTab: 'animals', screen: 'add' }
//   /reproduction/protocols/:id/edit { subTab: 'protocols', screen: 'edit', recordId }
// Forms open as a history entry and close by popping it (see useChildNav), so
// Back closes a form and never reopens a saved one.
export const useHubScreen = () => {
  const { pathname } = useLocation();
  const { open, close } = useChildNav();
  const [, tab, subTab, first, second] = pathname.split('/');
  const base = `/${tab}/${subTab}`;

  let screen = 'list';
  let recordId = null;
  if (FORM_SCREENS.includes(first) && second === undefined) screen = first;
  else if (first && second === 'edit') { screen = 'edit'; recordId = first; }

  // setScreen('edit', id, { protocol }) opens an edit form for a record; the
  // optional state hands the record over so the form needn't reload it.
  const setScreen = (next, id = recordId, extraState) => {
    if (next === screen && id === recordId) return;
    if (next === 'list') {
      if (screen !== 'list') close(base);
      return;
    }
    const path = next === 'edit' ? `${base}/${id}/edit` : `${base}/${next}`;
    open(path, extraState, { replace: screen !== 'list' });
  };

  return { subTab, screen, setScreen, recordId };
};

export default useHubScreen;
